import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'
import { Glyphs } from '../../glyphs'

export type WidgetMicroMenuItem = {
	id: string
	label: ReactNode
	onSelect: () => void
	disabled?: boolean
}

export interface WidgetMicroMenuProps {
	items: ReadonlyArray<WidgetMicroMenuItem>
	disabled?: boolean
	ariaLabel?: string
}

export function WidgetMicroMenu({ items, disabled = false, ariaLabel = 'Open menu' }: WidgetMicroMenuProps) {
	return (
		<Popover>
			{({ close }) => (
				<div className="size-full aspect-square grid place-items-center">
					<PopoverButton
						className={ctl(`
							text-sm text-grey-600 text-left bg-white ring ring-grey-200 rounded-full shadow-sm
							p-1
							grid place-items-center
							${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
						`)}
						disabled={disabled}
						aria-label={ariaLabel}
					>
						<Glyphs.micro.CogIcon />
					</PopoverButton>

					<PopoverPanel
						anchor="bottom"
						className="bg-white [--anchor-gap:8px] ring-1 ring-grey-100 shadow-md rounded text-sm text-grey-600"
					>
						<ul className="p-1">
							{items.map((item) => (
								<li key={item.id}>
									<button
										data-prevent-focus-loss
										className={ctl(`
											relative w-full text-left block
											cursor-pointer hover:bg-purple-100  hover:text-purple-700
                                            px-2 py-1 rounded
											${item.disabled ? 'cursor-not-allowed opacity-50' : ''}
										`)}
										onClick={() => {
											item.onSelect()
											close()
										}}
										disabled={item.disabled}
									>
										{item.label}
									</button>
								</li>
							))}
						</ul>
					</PopoverPanel>
				</div>
			)}
		</Popover>
	)
}
